export default function (state, data) {
    state.items = data;
}